import { IInvoice } from '../../../../../../app/entities/Invoice'
import { TYPES } from '../../../constants/invoice'

function isInvoiceRefund(invoice?: IInvoice): boolean {
  return [TYPES.ACCOMMODATION, TYPES.CORRECTION].includes(invoice?.type ?? '')
}

export default isInvoiceRefund